import { instantiateScope } from './blueprints'
import type { Bid, Home, Project } from './types'

const hvacScope = instantiateScope('hvac-replacement')

const cover = (values: Array<Bid['items'][number]['coverage']>): Bid['items'] => hvacScope.map((scopeItem, index) => ({
  scopeItemId: scopeItem.id,
  coverage: values[index] ?? 'unclear',
  evidence: values[index] === 'included' ? 'Stated in proposal' : undefined,
}))

export const demoHome: Home = {
  id: 'home-demo', name: 'Maple Street', propertyType: 'Single-family home', yearBuilt: 1987,
  climateZone: 'Mixed humid', region: 'Richmond, VA', healthScore: 78,
}

export const demoBids: Bid[] = [
  {
    id: 'bid-northstar', company: 'Northstar Mechanical', total: 18400, deposit: 1840, durationDays: 3,
    startWindow: 'Aug 12–19', laborWarrantyYears: 3, productWarrantyYears: 10, insuranceVerified: true, licenseVerified: true, status: 'revised',
    items: cover(['included', 'included', 'included', 'included', 'included', 'included', 'included', 'included']),
  },
  {
    id: 'bid-blue-ridge', company: 'Blue Ridge Comfort', total: 15950, deposit: 7975, durationDays: 2,
    startWindow: 'Aug 5–9', laborWarrantyYears: 1, productWarrantyYears: 10, insuranceVerified: true, licenseVerified: true, status: 'clarifying',
    items: cover(['unclear', 'included', 'allowance', 'included', 'included', 'unclear', 'included', 'included']),
  },
  {
    id: 'bid-copperline', company: 'Copperline Home Air', total: 21200, deposit: 4240, durationDays: 4,
    startWindow: 'Sep 3–12', laborWarrantyYears: 5, productWarrantyYears: 12, insuranceVerified: true, licenseVerified: false, status: 'received',
    items: cover(['included', 'included', 'unclear', 'included', 'included', 'included', 'included', 'allowance']),
  },
]

export const demoProject: Project = {
  id: 'project-demo', homeId: demoHome.id, title: 'Replace aging heat pump', type: 'hvac-replacement', status: 'deciding',
  targetBudget: 20000, targetStart: 'August 2026',
  summary: 'Replace the 18-year-old heat pump, correct comfort problems upstairs, and avoid equipment that is oversized for the existing duct system.',
  scope: hvacScope, bids: demoBids,
  priorities: { scope: 30, price: 20, warranty: 15, timeline: 10, confidence: 25 },
}

export const demoTimeline = [
  { date: 'Jul 21', title: 'Decision room opened', detail: 'Three bids normalized against the same eight-part scope.' },
  { date: 'Jul 19', title: 'Northstar revised proposal', detail: 'Added commissioning sheet and duct-balancing language.' },
  { date: 'Jul 17', title: 'Clarification sent', detail: 'Asked all bidders to identify matched-system model numbers.' },
  { date: 'Jul 12', title: 'Third bid received', detail: 'Copperline proposal added to the comparison.' },
]
